import {AsyncAction} from '../asyncUtilsTypes';
import {UserBaseDTO} from 'hemwb-api';

export enum ModelStewardActions {
  SET = 'MODEL_STEWARD/SET',
}

export type ModelStewardAction = AsyncAction<ModelStewardActions.SET, void, [string, UserBaseDTO]>;
